"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _Grid = _interopRequireDefault(require("@mui/material/Grid"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));

var _Button = _interopRequireDefault(require("@mui/material/Button"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _PdfFileRenderer = _interopRequireDefault(require("./PdfFileRenderer"));

var _reactAce = _interopRequireDefault(require("react-ace"));

require("ace-builds/webpack-resolver");

require("ace-builds/src-noconflict/theme-monokai");

require("ace-builds/src-noconflict/mode-json");

require("ace-builds/src-noconflict/ext-language_tools");

var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));

var renderFileName = function renderFileName(filename) {
  if (!filename) return '';
  var MAX_CHARS = 100;
  if (filename.length <= MAX_CHARS) return filename;
  var extension = filename.slice(filename.lastIndexOf('.'));
  var truncatedName = filename.slice(0, MAX_CHARS - extension.length - 3);
  return truncatedName + '...' + extension;
};

var PdfFileViewer = function PdfFileViewer(props) {
  var pdfUrl = props.pdfUrl,
      fileName = props.fileName,
      previewPage = props.previewPage,
      searchText = props.searchText,
      metaDataPreview = props.metaDataPreview,
      metaDataDebug = props.metaDataDebug;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      fileBin = _useState4[0],
      setFileBin = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showFileMetaDataDebug = _useState6[0],
      setShowFileMetaDataDebug = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      pdfFullHeight = _useState8[0],
      setPdfFullHeight = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      hasError = _useState10[0],
      setHasError = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      snackbackOpen = _useState12[0],
      setSnackbackOpen = _useState12[1];

  var _useState13 = (0, _react.useState)(''),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      snackbackMessage = _useState14[0],
      setSnackbackMessage = _useState14[1];

  var downloadPdfBin = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(pdfUrl) {
      var response, fileBlob;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setHasError(false);
              _context.prev = 2;
              _context.next = 5;
              return _axios.default.get(pdfUrl, {
                responseType: 'arraybuffer'
              });

            case 5:
              response = _context.sent;
              fileBlob = new Blob([response.data], {
                type: 'application/pdf'
              });
              setFileBin(fileBlob);
              _context.next = 15;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              setHasError(true);
              setSnackbackMessage(_context.t0 && _context.t0.message ? _context.t0.message : 'Unexpected Error occured');
              setSnackbackOpen(true);

            case 15:
              _context.prev = 15;
              setLoading(false);
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 15, 18]]);
    }));

    return function downloadPdfBin(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCloseSnackBar = (0, _react.useCallback)(function () {
    setSnackbackOpen(false);
  }, []);
  (0, _react.useEffect)(function () {
    downloadPdfBin(pdfUrl);
  }, [pdfUrl]);

  if (loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-center w-full"
    }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null));
  }

  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    direction: "column",
    style: {
      height: '100%',
      flexWrap: 'nowrap',
      padding: '1rem',
      maxHeight: '100vh'
    }
  }, /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: snackbackOpen,
    onClose: handleCloseSnackBar,
    autoHideDuration: 5000,
    message: snackbackMessage
  }), !pdfFullHeight && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h1",
    className: "file-info-title !mb-2.5 !font-semibold !text-[1.7rem]"
  }, renderFileName(fileName))), metaDataPreview && !pdfFullHeight && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative flex flex-wrap [&_p]:text-base"
  }, Object.keys(metaDataPreview).map(function (key, idx) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "file-info-row mb-[10px] flex items-center basis-1/2",
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1",
      className: "file-info-key w-[200px]"
    }, key, ":"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1",
      className: "font-semibold file-info-value"
    }, metaDataPreview[key]));
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, metaDataDebug && !pdfFullHeight && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return setShowFileMetaDataDebug(function (prevState) {
        return !prevState;
      });
    },
    variant: "outlined"
  }, showFileMetaDataDebug ? 'Hide' : 'Show', " File Meta Data")), showFileMetaDataDebug && metaDataDebug && !pdfFullHeight && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_reactAce.default, {
    width: "100%",
    placeholder: "Query Data",
    mode: "json",
    theme: "monokai",
    name: "query-data",
    fontSize: 14,
    showPrintMargin: true,
    showGutter: true,
    highlightActiveLine: true,
    value: JSON.stringify(metaDataDebug, null, 2),
    setOptions: {
      readOnly: true,
      maxLines: Infinity
    }
  })), !hasError ? /*#__PURE__*/_react.default.createElement(_PdfFileRenderer.default, {
    fileBin: fileBin,
    fileName: fileName,
    previewPage: previewPage ? parseInt(previewPage) : null,
    searchText: searchText,
    pdfFullHeight: pdfFullHeight,
    setPdfFullHeight: setPdfFullHeight
  }) : 'No PDF available');
};

var _default = PdfFileViewer;
exports.default = _default;